import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { IFBFileHeaders } from '@app/models/file';
import { IFBFileUploadApiResponse } from '@interfaces';

@Injectable({
  providedIn: 'root'
})
export class FileResource {
  constructor(private http: HttpClient) {}

  private get url(): string {
    return `https://files.${environment.SERVICES_BASE}/api/files`;
  }

  public upload(file: File, headersData: IFBFileHeaders = null) {
    const headers = new HttpHeaders({
      'X-Filename': encodeURIComponent(headersData['X-Filename'] || file.name),
      ...(headersData['X-Transformations'] && { 'X-Transformations': headersData['X-Transformations'] }),
      ...(headersData['X-Transformations-Mime-Type'] && {
        'X-Transformations-Mime-Type': headersData['X-Transformations-Mime-Type']
      })
    });

    return this.http.post<IFBFileUploadApiResponse>(`${this.url}/binary`, file, { headers });
  }

  public uploadBase64(content: string, headersData: IFBFileHeaders = null) {
    const headers = new HttpHeaders({
      ...(headersData['X-Transformations'] && { 'X-Transformations': headersData['X-Transformations'] }),
      ...(headersData['X-Transformations-Mime-Type'] && {
        'X-Transformations-Mime-Type': headersData['X-Transformations-Mime-Type']
      })
    });

    return this.http.post<{ id: string }>(
      `https://files.${environment.SERVICES_BASE}/files/v1/base64`,
      {
        contentBase64: content.replace(/^data:image\/(png|jpg|jpeg);base64,/, ''),
        contentType: 'image/png',
        name: headersData['X-Filename'] || headersData.name
      },
      { headers }
    );
  }
}
